<template>
  <div class="shops-filter custom-scrollbar" :class="{'shops-filter--modal': modal, 'shops-filter--services': isServices}">
    <div class="shops-filter__modal">
      <div class="shops-filter__city-wrap">
        <button @click="FIND_ME" class="shops-filter__find-me-btn">
          <svg width="15"
               height="15"
               viewBox="0 0 15 15"
               fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <path d="M11.9501 1.84469C9.49062 -0.614765 5.50974 -0.61503 3.05002 1.84469C0.590616 4.30406 0.590234 8.28504 3.05002 10.7448L7.16746 14.8622C7.35117 15.0459 7.64898 15.0459 7.83267 14.8622L11.9501 10.7448C14.4095 8.28539 14.4099 4.30445 11.9501 1.84469ZM9.48939 8.28404C8.39001 9.38344 6.61035 9.38368 5.51071 8.28404C4.41128 7.1846 4.4111 5.405 5.51071 4.30542C6.61005 3.20601 8.38975 3.20581 9.48936 4.30542C10.5888 5.40479 10.589 7.18446 9.48939 8.28404Z" fill="#909090"/>
          </svg>
          <span>
            {{ $t('my_current_place') }}
          </span>
        </button>
        <div class="shops-filter__select-city-wrap">
          <GeoSelectCity shops-filter without-update-location type="select" />
        </div>
        <div class="shops-filter__checkbox-wrap">
          <Checkbox @input="handleCheckbox($event, 'opened')"
                    :value="filteredFlags['opened']"
                    :name="'opened' + _uid"
                    filled>
            <span class="shops-filter__check-text">{{ $t('shops_filters_opened') }}</span>
          </Checkbox>
          <!-- Checkbox @input="handleCheckbox($event, 'near_subway')" :value="filteredFlags['near_subway']" :name="'near_subway' + _uid" filled>
            <span class="shops-filter__check-text">{{ $t('shops_filters_near_subway') }}</span>
          </Checkbox -->
        </div>
        <div v-if="toggleMapList" class="shops-filter__mobile-nav">
          <div
            class="shops-filter__mobile-nav--map"
            :class="{ 'is-active': isMapActive }"
            @click="SET_IS_MAP_TAB_ACTIVE_ACTION(true)"
          >
            <span>{{ $t('map_modal_map_title') }}</span>
          </div>
          <div
            class="shops-filter__mobile-nav--list"
            :class="{ 'is-active': !isMapActive }"
            @click="SET_IS_MAP_TAB_ACTIVE_ACTION(false)"
          >
            <span>{{ $t('map_modal_list_title') }}</span>
          </div>
        </div>
      </div>
      <template v-if="filterByServices">
        <div class="shops-filter__services-header">
          <Checkbox @input="handleAllServices"
                    :value="isAllCheckboxSelected"
                    :name="'check' + _uid"
                    filled>
            <span class="shops-filter__check-text shops-filter__check-text--big">{{ $t('shops_filters_all_services') }}</span>
          </Checkbox>
        </div>
        <div class="shops-filter__services-list-wrap">
          <ul class="shops-filter__services-list">
            <li class="shops-filter__services-item" v-for="(service, i) in services" :key="i">
              <Checkbox @input="handleCheckbox($event, service.key, 'service')"
                        :value="filteredFlags.services[service.key]"
                        :name="service.key + _uid"
                        filled>
                <div class="shops-filter__check-slot">
                  <img :src="service.icon"
                       :alt="service.label"
                       class="shops-filter__check-icon"
                       :class="{'shops-filter__check-icon--color': filteredFlags.services[service.key]}">
                  <span class="shops-filter__check-text">{{ service.label }}</span>
                  <span class="shops-filter__additional-info"
                        v-if="!modal && service.additional_text"
                        @mouseenter="handleTooltip($event, service.key)"
                        @mouseleave="handleTooltip($event,null)">
                    ?
                    <Tooltip :html-text="service.additional_text" :is-visible="visibleTooltip === service.key" />
                  </span>
                </div>
              </Checkbox>
            </li>
          </ul>
          <div v-if="!hotUpdateFilters" class="shops-filter__button-wrap">
            <Button class="shops-filter__button" @click.native="handleApprovedFilters">{{ $t('shops_filters_approve_filters_btn') }}</Button>
          </div>
        </div>
      </template>
      <div v-else class="shops-filter__shops-wrap custom-scrollbar"  :class="{'shops-filter__shops-wrap--hidden': isMapActive}">
        <ul class="shops-filter__shops-list">
          <li class="shops-filter__shop-item" v-for="(spot, idx) in spotsInfo" :key="idx + Math.random()">
            <ShopsFilterShopCard
              :shop-data="spot"
              @select-shop="selectSpot"
            />
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Checkbox from '@/components/inputs/Checkbox'
import GeoSelectCity from '@/components/user-geo/GeoSelectCity'
import Tooltip from '@/components/helpers/Tooltip'
import Button from '@/components/inputs/Button'
import ShopsFilterShopCard from '@/components/shops/ShopsFilterShopCard'

export default {
  name: 'ShopsFilter',
  components: { ShopsFilterShopCard, Button, Tooltip, GeoSelectCity, Checkbox },
  data () {
    return {
      visibleTooltip: null
    }
  },
  props: {
    modal: {
      type: Boolean,
      default: false
    },
    hotUpdateFilters: {
      type: Boolean,
      default: false
    },
    filterByServices: {
      type: Boolean,
      default: false
    },
    toggleMapList: {
      type: Boolean,
      default: false
    },
    spotsInfo: {
      type: Array,
      default: () => []
    },
    isServices: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      map: state => state.map.map,
      isMapActive: state => state.deliveryForm.isMapTabActive,
      markers: state => state.map.markers,
      selectedSpot: state => state.map.selectedSpot,
      citiesZoom: state => state.map.citiesZoom,
      filteredFlags: state => state.shops.filteredFlags,
      filters: state => state.shops.filters,
      popularCities: state => state.geoLocation.popularCities,
      services: state => state.shops.services
    }),
    isAllCheckboxSelected () {
      return !!(Object.values(this.filteredFlags.services).length && !Object.values(this.filteredFlags.services).includes(false))
    },
    selectedFilters () {
      return this.handleSelectedFilters()
    }
  },
  methods: {
    ...mapActions([
      'SET_FILTERED_FLAGS_ACTION',
      'SET_SHOPS_FILTERS_ACTION',
      'SET_SHOPS_FILTERS_FROM_URL_ACTION',
      'SET_FILTERS_TO_URL',
      'FETCH_DELIVERY_CITIES',
      'FIND_ME',
      'HANDLE_ADDRESS_SEARCH',
      'INIT_AUTOCOMPLETE',
      'OPEN_INFO_WINDOW',
      'SET_SELECTED_SPOT_ACTION',
      'SET_IS_MAP_TAB_ACTIVE_ACTION'
    ]),
    handleSelectedFilters () {
      const result = {}

      for (let item in this.filteredFlags) {
        if (this.filteredFlags.hasOwnProperty(item)) {
          if (typeof this.filteredFlags[item] === 'object') {
            const arr = []

            for (let key in this.filteredFlags[item]) {
              if (this.filteredFlags[item].hasOwnProperty(key) && this.filteredFlags[item][key]) {
                arr.push(key)
              }
            }

            result[item] = arr
          } else {
            if (this.filteredFlags[item]) {
              result[item] = this.filteredFlags[item].toString()
            }
          }
        }
      }

      return result
    },
    handleCheckbox (data, name, type) {
      this.SET_FILTERED_FLAGS_ACTION({ key: name, value: data, type: type === 'service' ? 'service' : '' })
    },
    handleAllServices (bool) {
      for (let key in this.filteredFlags.services) {
        if (this.filteredFlags.services.hasOwnProperty(key)) {
          this.SET_FILTERED_FLAGS_ACTION({ key: key, value: bool, type: 'service' })
        }
      }
    },
    handleTooltip (e, service) {
      e.stopPropagation()
      this.visibleTooltip = service
    },
    handleApprovedFilters () {
      this.SET_SHOPS_FILTERS_ACTION(this.handleSelectedFilters())
      this.SET_FILTERS_TO_URL()
      this.$emit('approved-filters')
    },
    selectSpot (spot) {
      this.map.setCenter({ lat: +spot.latitude, lng: +spot.longitude })

      this.markers.forEach(marker => {
        if (marker.title === spot.title) {
          this.OPEN_INFO_WINDOW({ marker, spot, mailName: 'pickup' })
        }
      })
    }
  },
  mounted () {
    if (this.filterByServices) {
      this.services.forEach((service) => {
        this.SET_FILTERED_FLAGS_ACTION({
          key: service.key,
          value: this.filters[this.$constants.SHOPS_FILTERS_FLAGS.SERVICES] ? this.filters[this.$constants.SHOPS_FILTERS_FLAGS.SERVICES].includes(service.key) : false,
          type: 'service'
        })
      })
    }

    if (this.filters[this.$constants.SHOPS_FILTERS_FLAGS.OPENED]) {
      this.SET_FILTERED_FLAGS_ACTION({ key: this.$constants.SHOPS_FILTERS_FLAGS.OPENED, value: true })
    }
    if (this.filters[this.$constants.SHOPS_FILTERS_FLAGS.NEAR_SUBWAY]) {
      this.SET_FILTERED_FLAGS_ACTION({ key: this.$constants.SHOPS_FILTERS_FLAGS.NEAR_SUBWAY, value: true })
    }

    if (this.toggleMapList) {
      this.SET_IS_MAP_TAB_ACTIVE_ACTION(true)
    }
  },
  watch: {
    selectedFilters (value) {
      if (this.hotUpdateFilters) this.SET_SHOPS_FILTERS_ACTION(value)
    },
    filters () {
      this.SET_FILTERS_TO_URL()
    }
  }
}
</script>

<style scoped lang="sass">

.shops-filter:not(.shops-filter--modal):not(.shops-filter--services)
  display: none

  +mmin($mid)
    display: block

.shops-filter--services
  +mmin($mid)
    max-height: 600px
    overflow: auto

.shops-filter
  width: 100%
  min-width: 300px
  background: #FCFCFC
  border: 1px solid #E7E7E7

  +mmin($mid)
    width: 40%
    max-width: 400px

.shops-filter__city
  display: block
  width: 100%

.shops-filter__modal
  display: flex
  flex-flow: column
  width: 100%
  height: 100%

.shops-filter__city-wrap
  border-bottom: 1px solid $nd-border-color
  padding: 30px 25px

.shops-filter__services-header
  padding: 23px 25px 18.5px
  border-bottom: 1px solid $nd-border-color

.shops-filter__check-slot
  display: flex
  flex-flow: row nowrap

  img
    margin-right: 15px

.shops-filter__check-icon
  display: block
  width: 20px
  height: 20px
  object-fit: contain
  filter: grayscale(1)

  &--color
    filter: none

.shops-filter__check-text
  margin-top: 2px
  font-size: 14px
  line-height: 1.3

  +mmin($tablet--hor)
    font-size: 16px

  &--big
    font-size: 16px

    +mmin($tablet--hor)
      font-size: 18px

  &--gray
    color: $placeholder-color

.shops-filter__services-list-wrap
  padding: 20px 25px 30px

.shops-filter__services-list
  +list-unstyled

.shops-filter__services-item
  margin-bottom: 15px

.shops-filter__find-me-btn
  display: flex
  flex-flow: row nowrap
  align-items: center
  background-color: transparent
  padding: 0
  border: none
  margin-bottom: 20px

  span
    font-size: 16px
    color: $placeholder-color
    border-bottom: 1px solid $placeholder-color
    margin-left: 15px

  &:hover
    span
      color: $main-color
      border-color: $main-color

    svg path
      fill: $main-color

.shops-filter__select-city-wrap
  margin-bottom: 30px

.shops-filter__checkbox-wrap
  display: flex
  flex-flow: row wrap

  div:first-child
    margin-right: 25px

  div:last-child
    margin-bottom: 0

  div:not(:last-child)
    margin-bottom: 10px

.shops-filter__additional-info
  display: flex
  justify-content: center
  align-items: center
  border-radius: 50%
  width: 16px
  height: 16px
  background-color: #e7e7e7
  color: $placeholder-color
  font-size: 14px
  margin-top: 4px
  margin-left: 10px
  line-height: 1

.shops-filter--modal
  border: none
  background: none
  width: 100%
  max-width: 100%

.shops-filter__button
  margin: 0 auto

.shops-filter__shops-wrap
  width: 100%
  height: 600px
  overflow: auto

  +mmin($mid)
    height: auto
    overflow: visible

  &--hidden
    display: none

    +mmin($mid)
      display: block

.shops-filter__shops-list
  +list-unstyled

.shops-filter__shop-item
  border-bottom: 1px solid $nd-border-color

.shops-filter__mobile-nav
  width: 100%
  display: flex
  flex-flow: row-reverse
  justify-content: space-between
  order: 0
  margin: 20px 0 0
  background-color: #f5f5f5
  padding: 4px
  border-radius: 3px

  &--map, &--list
    width: 49%
    text-align: center
    font-size: 14px
    line-height: 18px
    padding: 8px
    background-color: transparent
    cursor: pointer

  .is-active
    background-color: $white-text-color
    border-radius: 3px
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.05)

  +mmin($mid)
    display: none
</style>
